import LGBTQ from './LGBTQ';
import ac from './ac';
import allInclusive from './all_inclusive';
import aquaGym from './aqua_gym';
import arte from './arte';
import azafata from './azafata';
import babyFriendly from './baby_friendly';
import badminton from './badminton';
import bakery from './bakery';
import barDeTragos from './bar_de_tragos';
import basketball from './basketball';
import beach from './beach';
import beerPaint from './beer_paint';
import bicycle from './bicycle';
import billar from './billar';
import botSail from './bot_sail';
import breakfast from './breakfast';
import brillos from './brillos';
import brunch from './brunch';
import carRental from './car_rental';
import cardFill from './card_fill';
import casino from './casino';
import chefCocina from './chef_cocina';
import childCare from './child_care';
import cleaningService from './cleaning_service';
import closet from './closet';
import concierge from './concierge';
import conferenceRoom from './conference_room';
import currencyExchange from './currency_exchange';
import deck from './deck';
import desfibrilator from './desfibrilator';
import doctor from './doctor';
import dryCleaning from './dry_cleaning';
import dryer from './dryer';
import eGames from './e_games';
import ecoFriendly from './eco_friendly';
import edificio from './edificio';
import elevator from './elevator';
import entertainment from './entertainment';
import family from './family';
import fireplace from './fireplace';
import girlGym from './girl_gym';
import golf from './golf';
import grillBbc from './grill_bbc';
import gym from './gym';
import hairSaloon from './hair_saloon';
import jacuzzi from './jacuzzi';
import laundry from './laundry';
import library from './library';
import luggageCart from './luggage_cart';
import meetingRoom from './meeting_room';
import mobileOk from './mobile_ok';
import moneyOff from './money_off';
import multipleCard from './multiple_card';
import nightClub from './night_club';
import nightLife from './night_life';
import parking from './parking';
import petfriendly from './petfriendly';
import phone from './phone';
import photocamara from './photocamara';
import pingPong from './ping_pong';
import pool from './pool';
import poolTable from './pool_table';
import proyector from './proyector';
import restaurant from './restaurant';
import roomService from './room_service';
import safeBox from './safe_box';
import sauna from './sauna';
import scubadiving from './scubadiving';
import securityCam from './security_cam';
import seguridad from './seguridad';
import shop from './shop';
import smokeDetector from './smoke_detector';
import smokeFree from './smoke_free';
import smoking from './smoking';
import solarium from './solarium';
import spa from './spa';
import sportsDeportes from './sports_deportes';
import starFilled from './star_filled';
import surf from './surf';
import tennis from './tennis';
import transfer from './transfer';
import tv from './tv';
import valetParking from './valet_parking';
import veggie from './veggie';
import volley from './volley';
import volunteerActivism from './volunteer_activism';
import waterSki from './water_ski';
import wheelChair from './wheel_chair';
import wifi from './wifi';

type Amenities = Record<string, () => JSX.Element>;

export const amenities: Amenities = {
  LGBTQ,
  ac,
  allInclusive,
  aquaGym,
  arte,
  azafata,
  babyFriendly,
  badminton,
  bakery,
  barDeTragos,
  basketball,
  beach,
  beerPaint,
  bicycle,
  billar,
  botSail,
  breakfast,
  brillos,
  brunch,
  carRental,
  cardFill,
  casino,
  chefCocina,
  childCare,
  cleaningService,
  closet,
  concierge,
  conferenceRoom,
  currencyExchange,
  deck,
  desfibrilator,
  doctor,
  dryCleaning,
  dryer,
  eGames,
  ecoFriendly,
  edificio,
  elevator,
  entertainment,
  family,
  fireplace,
  girlGym,
  golf,
  grillBbc,
  gym,
  hairSaloon,
  jacuzzi,
  laundry,
  library,
  luggageCart,
  meetingRoom,
  mobileOk,
  moneyOff,
  multipleCard,
  nightClub,
  nightLife,
  parking,
  petfriendly,
  phone,
  photocamara,
  pingPong,
  pool,
  poolTable,
  proyector,
  restaurant,
  roomService,
  safeBox,
  sauna,
  scubadiving,
  securityCam,
  seguridad,
  shop,
  smokeDetector,
  smokeFree,
  smoking,
  solarium,
  spa,
  sportsDeportes,
  starFilled,
  surf,
  tennis,
  transfer,
  tv,
  valetParking,
  veggie,
  volley,
  volunteerActivism,
  waterSki,
  wheelChair,
  wifi,
};
